/**
 * CSS injection utilities for the grid widget
 */

import { logger } from "../../shared/logger";

export const CSS_TAG_ID = "__nxw_widget_css";
export const CUSTOM_CSS_TAG_ID = "__nxw_custom_css";
export const PREVIEW_CSS_TAG_ID = "__nxw_dynamic_css_layer"; // GridWidgetStyleLayer's CSS tag

export function injectCss(cssText) {
  if (!cssText) return;
  // Skip injection if in preview/editor mode (GridWidgetStyleLayer handles CSS)
  if (document.getElementById(PREVIEW_CSS_TAG_ID)) {
    logger.log("[Widget] Skipping CSS injection - preview mode detected");
    return;
  }
  let tag = document.getElementById(CSS_TAG_ID);
  if (!tag) {
    tag = document.createElement("style");
    tag.id = CSS_TAG_ID;
    document.head.appendChild(tag);
  }
  tag.textContent = cssText;
}

// Inject user's custom CSS
export function injectCustomCss(cssText) {
  if (!cssText) return;
  // Skip if in preview mode (GridWidgetStyleLayer handles it)
  if (document.getElementById(PREVIEW_CSS_TAG_ID)) {
    return;
  }
  let tag = document.getElementById(CUSTOM_CSS_TAG_ID);
  if (!tag) {
    tag = document.createElement("style");
    tag.id = CUSTOM_CSS_TAG_ID;
    document.head.appendChild(tag);
  }
  tag.textContent = cssText;
}
